import { useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

interface VisibilitySensorWrapperProps {
  onWasSeen?: () => void;
  children: React.ReactNode;
}

export const TrackVisibilitySensor: React.FC<VisibilitySensorWrapperProps> = ({
  onWasSeen,
  children,
}) => {
  const [wasSeen, setWasSeen] = useState(false);
  return (
    <VisibilitySensor
      active={!wasSeen}
      onChange={(isVisible: boolean) => {
        if (!isVisible || wasSeen) return;
        setWasSeen(true);
        onWasSeen?.();
      }}
    >
      {children}
    </VisibilitySensor>
  );
};
